<template>
  <div class="d-flex w-100 h-100">
    <Loading v-if="loading === true" class="mt-5 pt-4" />
    <table
      class="table table-standard table-sm table-latest-transactions"
      v-if="loading === false"
    >
      <thead>
        <tr>
          <th>Dátum</th>
          <th>Typ</th>
          <th>Suma</th>
          <th>Mena</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items">
          <td>{{ item.date | date }}</td>
          <td>{{ item.type | truncate(20) }}</td>
          <td>{{ item.value | price }}</td>
          <td>{{ item.currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Loading from "./Loading";

export default {
  name: "LatestTransactions",
  components: { Loading },
  mounted() {
    this.$store.dispatch("transactions/dashboardTransactions", {
      limit: 8
    });
  },
  computed: {
    items() {
      return this.$store.state.transactions.dashboardTransactions;
    },
    loading() {
      return this.$store.state.transactions.loading;
    }
  }
};
</script>

<style lang="scss">
.table-latest-transactions {
  font-size: 11.5px !important;

  td {
    white-space: nowrap;
  }

  tr td:nth-child(2) {
    width: 10px !important;
  }
}
</style>
